import { create } from "zustand";
import { WEB_PARAMS } from "../config/Constant";
import { fetchCityFromCoordinates } from "../api/homeApi";

const useLocationStore = create((set, get) => ({
  userLocation: (() => {
    const raw = localStorage.getItem(WEB_PARAMS.USER_LOCATION);
    try {
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  })(),
  cityName: localStorage.getItem(WEB_PARAMS.CITY_NAME) || "",
  stateName: localStorage.getItem(WEB_PARAMS.STATE_NAME) || "",
  isLocationLoading: false,
  locationError: null,
  locationResolved: false,

  /**
   * Updates the location and fetches the city name automatically.
   */
  updateLocation: async () => {
    if (!navigator.geolocation) {
      set({ locationError: "Geolocation not supported", locationResolved: true });
      return;
    }

    set({ isLocationLoading: true, locationError: null });

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const coords = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };

        // Update coordinates in store and localStorage
        localStorage.setItem(WEB_PARAMS.USER_LOCATION, JSON.stringify(coords));
        set({ userLocation: coords });

        // Fetch city name from coordinates
        await get().fetchCity(coords);
      },
      (error) => {
        set({
          locationError: "Permission denied or failed to fetch position",
          isLocationLoading: false,
          locationResolved: true,
        });
      }
    );
  },

  fetchCity: async (coords) => {
    set({ isLocationLoading: true });
    try {
      const { city, state } = await fetchCityFromCoordinates(coords);
      if (city) {
        localStorage.setItem(WEB_PARAMS.CITY_NAME, city);
        localStorage.setItem(WEB_PARAMS.STATE_NAME, state);
        set({ cityName: city, stateName: state, isLocationLoading: false, locationResolved: true });
      } else {
        set({ isLocationLoading: false, locationResolved: true });
      }
    } catch (error) {
      set({ isLocationLoading: false, locationResolved: true });
    }
  },

  setCityName: (name) => {
    localStorage.setItem(WEB_PARAMS.CITY_NAME, name);
    set({ cityName: name });
  },

  setStateName: (name) => {
    localStorage.setItem(WEB_PARAMS.STATE_NAME, name);
    set({ stateName: name });
  },

  clearLocationError: () => set({ locationError: null }),
}));

export default useLocationStore;
